import { createTealiumTracking as r, NOT_SET as e, ElementTrackingIds as n } from "@sunrise/tracking";
var m = /* @__PURE__ */ ((t) => (t.LEVEL1 = "level1", t.LEVEL2 = "level2", t))(m || {});
function i() {
  return {
    mslayer_element_data_id: n.HEADER_NAVI,
    mslayer_element_type_text: e,
    mslayer_element_count: e,
    mslayer_element_variant: "default",
    mslayer_element_body_type: "header",
    mslayer_element_id: e,
    mslayer_affiliate_id: e,
    mslayer_element_company_name: e,
    mslayer_element_detail_start_date: e
  };
}
function y(t, a, _, l) {
  return [
    r({
      ...i(),
      mslayer_element_position: `${t}`,
      mslayer_element_text: `navi_${a}_${_}_${l.replace(/ /g, "_")}`
    })
  ];
}
export {
  m as HeaderNavLevel,
  y as buildTrackingData,
  i as getBaseTracking
};
